import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { routes } from "./routes/public.routes";

const CustomRoute = (route: any) => {
  return route.redirect ? (
    <Redirect from={route.path} to={route.redirect}></Redirect>
  ) : (
    <Route
      path={route.path}
      render={(props) => (
        // pass the sub-routes down to keep nesting
        <route.component {...props} routes={route.routes} />
      )}
    />
  );
};

const PublicRoute = () => {
  return (
    <Route>
      <Switch>
        {routes.map((route, i) => (
          <CustomRoute key={i} {...route} />
        ))}
      </Switch>
    </Route>
  );
};

export default PublicRoute;
